import { render } from "./LayoutsAuthSidebarContentSubmenu.vue?vue&type=template&id=38e7da11&ts=true"
import script from "./LayoutsAuthSidebarContentSubmenu.vue?vue&type=script&lang=ts"
export * from "./LayoutsAuthSidebarContentSubmenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__